import React from 'react';
import { Box, Typography } from '@mui/material';
import { Button } from '@intugine-technologies/mui';
import Dialog from '../Dialog/Dialog';
import { useTheme } from '@mui/material/styles';

const PaymentReminderDialog = ({ open, onClose }) => {
  const theme = useTheme();

  const handleClose = () => {
    onClose();
  };

  const handlePaymentAction = () => {
    // Add payment action logic here
    // This could redirect to payment page or open payment modal
    console.log('Payment action triggered');
    onClose();
  };

  return (
    <Dialog
      open={open}
      setClose={handleClose}
      heading="Payment Reminder"
      width={500}
      height={200}
      buttonAction={
        <>
          <Button
            text="Remind Later"
            size="small"
            variant="outlined"
            color="secondary"
            onClick={handleClose}
          />
         
        </>
      }
    >
      <Box sx={{ padding: '24px 40px' }}>
        {/* <Typography variant="body1" sx={{ marginBottom: '16px', color: theme.palette.text.primary }}>
        Payment Reminder
        </Typography> */}
        
        
          <Box sx={{ 
            backgroundColor: theme.palette.warning.light, 
            padding: '12px', 
            borderRadius: '4px',
            marginBottom: '16px'
          }}>
            <Typography variant="body1" sx={{ color: theme.palette.warning.dark }}>
            We regret to inform that the payments is now significantly past due. We urge you to make the necessary payment as soon as possible to avoid any disruption to your service
            </Typography>
           
          </Box>
      
        
        <Typography variant="body2" sx={{ color: theme.palette.text.secondary }}>
          Please complete your payment to continue using our services without interruption.
        </Typography>
      </Box>
    </Dialog>
  );
};

export default PaymentReminderDialog; 